import React, { useState, useEffect } from "react";
import { useLanguage } from "../../i18n/LanguageContext";

const ContactUs = () => {
  const [iframeSrc, setIframeSrc] = useState("");
  const { t } = useLanguage();

  useEffect(() => {
    // Limpiar TODO el localStorage y sessionStorage
    // (conservando el idioma elegido por el visitante)
    const language = localStorage.getItem("language");
    localStorage.clear();
    sessionStorage.clear();
    if (language) localStorage.setItem("language", language);

    // Borrar todas las cookies del dominio
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    // Forzar iframe completamente nuevo con prefill vacío y timestamp único
    const freshSrc = `https://calendly.com/yoel-alvarez-taxsolutionscorp?hide_gdpr_banner=1&name=&email=&phone=&a1=&a2=&a3=&t=${Date.now()}`;
    setIframeSrc(freshSrc);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <div className="pt-28 pb-16">
        <div className="max-w-4xl mx-auto px-4">
          <div className="bg-white shadow-sm rounded-lg">
            {iframeSrc && (
              <iframe
                key={iframeSrc}
                src={iframeSrc}
                width="100%"
                height="700px"
                frameBorder="0"
                title={t.contact.iframeTitle}
                style={{ border: "none", minWidth: "320px" }}
              ></iframe>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
